module.exports = __webpack_public_path__ + "Roboto-Light.3b813c2ae0d04909a33a.woff";


//////////////////
// WEBPACK FOOTER
// C:/Users/bompadre/Documents/angular2/myapp2/font/roboto/Roboto-Light.woff
// module id = ../../../../../font/roboto/Roboto-Light.woff
// module chunks = styles